<template>
  <div>
    <div class="content-heading">
        <i class="ic-head-icon">
          <img src="@/assets/images/sidebar/dstore.svg" alt="D-Store" height="23">
        </i>
        <h4 class="head-title">D-Store</h4>
        <i class="ic-tooltip" id="help"></i>
        <b-popover target="help"
          triggers="hover"
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.">
        </b-popover>
        <app-tab :tabs="tabs"></app-tab>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import AppTabs from "@/components/common/AppTabs.vue";

const tabs = [
    {
        name: "Products",
        href: "/dstore/products",
        access: "dstore:topup.inventory:topup-dstore"
    },
    {
        name: "Orders",
        href: "/dstore/orders",
        access: "dstore:topup.orders:topup-dstore"
    },
    {
        name: "Store Vouchers",
        href: "/dstore/store-vouchers",
        access: "dstore:topup.vouchers:topup-dstore"
    },
    {
        name: "Design",
        href: "/dstore/design",
        access: "dstore:topup.design:topup-dstore"
    },
    {
        name: "Activation Key",
        href: "/dstore/activation-key",
        access: "dstore:topup.activation:topup-dstore"
    },
    {
        name: "Settings",
        href: "/dstore/settings",
        access: "dstore:topup.settings:topup-dstore"
    }
];

export default {
    name: "DStoreNav",
    components: {
        "app-tab": AppTabs
    },
    data() {
        return {
            tabs: tabs
        };
    }
};
</script>

<style lang="scss">
</style>
